module.exports = __webpack_public_path__ + "img/korkep-back.7f05d384.png";